__turbopack_context__.v({
  "blingBanner": "HeroBanner-module__wFYiJW__blingBanner",
  "blingBannerContent": "HeroBanner-module__wFYiJW__blingBannerContent",
  "blingBannerFrame": "HeroBanner-module__wFYiJW__blingBannerFrame",
  "blingCta": "HeroBanner-module__wFYiJW__blingCta",
  "blingPricing": "HeroBanner-module__wFYiJW__blingPricing",
  "blingStartsFrom": "HeroBanner-module__wFYiJW__blingStartsFrom",
  "blingTaxNote": "HeroBanner-module__wFYiJW__blingTaxNote",
  "blingTextCol": "HeroBanner-module__wFYiJW__blingTextCol",
  "blingTitle": "HeroBanner-module__wFYiJW__blingTitle",
  "featuredBanner": "HeroBanner-module__wFYiJW__featuredBanner",
  "featuredSleepingMask": "HeroBanner-module__wFYiJW__featuredSleepingMask" + " " + "HeroBanner-module__wFYiJW__featuredBanner",
  "featuredStrikedPrice": "HeroBanner-module__wFYiJW__featuredStrikedPrice",
  "heroBanner": "HeroBanner-module__wFYiJW__heroBanner",
});
